import socket from './socket'
import version from '@/api/version'
import store from '@/store'

const versionCheckDelay = 900000 // 15 minutes
const editCheckDelay = 300000 // 5 minutes
const tenDaysEpochUnix = 518400 // 10 days in seconds

let timer = null

const notification = {
  key: 'version',
  message: 'An update to this site is available. Click this message to reload.'
}

const isApp = navigator.userAgent.indexOf('ProjectBoardApp') >= 0

export default {
  start: function () {
    socket.subscribeAll('version')

    if (isApp) {
      notification.message = notification.message.replace('site', 'app')
      document.addEventListener('appResume', function () {
        this.check()
      }.bind(this), false)
    }

    this.check()
  },
  stop: function () {
    socket.unsubscribeAll('version')
    if (timer) {
      clearTimeout(timer)
    }
  },
  check: function () {
    const checkEditState = store.getters.componentGetValue('isEditing')
    if (checkEditState === true) {
      return this.checkDelay(editCheckDelay)
    }

    if (process.env.NODE_ENV !== 'production') {
      return
    }

    if (timer) {
      clearTimeout(timer)
    }

    version.get().then((response) => {
      const currentVersion = response.data.result.version

      if (isNaN(currentVersion)) {
        return
      }

      const timeDifference = currentVersion - process.env.FRONTEND_VERSION

      // If the latest version is 10 days older than the frontend version, add the click to update bar
      if (timeDifference > tenDaysEpochUnix) {
        store.dispatch('addNotification', notification)
      }
    })

    this.checkDelay(versionCheckDelay)
  },
  checkDelay: function (delay) {
    if (timer) {
      clearTimeout(timer)
    }

    timer = setTimeout(() => {
      this.check()
    }, delay)
  }
}
